exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".category-manage[data-v-b94b9dc8]{padding:20px}.search-bar[data-v-b94b9dc8]{margin-bottom:20px;display:flex;align-items:center}.add-section[data-v-b94b9dc8]{margin-bottom:20px}.dialog-footer[data-v-b94b9dc8]{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-b94b9dc8&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/course/categoryManage.vue
// module id = 620
// module chunks = 0